import React from "react";

import { Box, Flex, Text } from "src/components";

import Button from "./Button";
import ValidationIcon from "./ValidationIcon";

const styleForButtonStyle = buttonStyle => {
  switch (buttonStyle) {
    case "circle":
      return {
        height: 48,
        width: 48,
        borderRadius: 24,
        paddingLeft: 0,
        paddingRight: 0,
        paddingBottom: 0,
        paddingTop: 0,
        flex: "none",
      };
    default:
      return {};
  }
};

const OptionButton = ({
  label,
  selected,
  onPress,
  color = "green",
  buttonStyle,
  numeric,
}) => (
  <Button
    title={label}
    mx={2}
    mb={[2, 2, 2, 0]}
    type="button"
    bg={selected ? color : "muted"}
    onClick={onPress}
    style={styleForButtonStyle(buttonStyle)}
    numeric={numeric}
  />
);

export default props => (
  <Flex
    mx={[0, 0, 3]}
    mt={2}
    mb={props.wrap ? 2 : [0, 0, 0, 3]}
    flex="1 0 auto"
    flexDirection={
      props.wrap ? "column" : ["column", "column", "column", "row"]
    }
    align={props.wrap ? undefined : ["stretch", "stretch", "stretch", "center"]}
  >
    <Flex mr={3}>
      <Text fontWeight="semibold" mr={2}>
        {props.label}
      </Text>

      <ValidationIcon {...props} />
    </Flex>
    {props.renderHelpText({
      containerProps: {
        mt: 1,
        mb: 1,
      },
    })}
    <Flex
      flexDirection={
        props.buttonStyle === "circle"
          ? ["column", "row"]
          : ["column", "column", "column", "row"]
      }
      flex={1}
      align={
        props.buttonStyle === "circle" ? ["center", "flex-start"] : ["stretch"]
      }
      mx={-2}
      my={props.wrap ? 2 : [2, 2, 2, 0]}
      style={{ flexWrap: "wrap" }}
    >
      {props.options.map(option => (
        <OptionButton
          key={option.value}
          color={option.color}
          label={option.label || option.value}
          onPress={e => {
            props.onTouch();
            props.setValue(option.value);
          }}
          selected={props.value === option.value}
          buttonStyle={props.buttonStyle}
          numeric={props.numeric}
        />
      ))}
    </Flex>
  </Flex>
);



// WEBPACK FOOTER //
// ./src/components/Form/OptionButtons.js